import { CardFormFactor, CardType } from '../../../../enums';
import { ProductOption } from '../../../../models/Options';
import { cardFormFactorOptionValueIds } from './constants';

export const getCardFormFactorOptionValueId = (
  cardFormFactor: CardFormFactor,
): number => {
  if (cardFormFactor === CardFormFactor.Plastic)
    return cardFormFactorOptionValueIds.plastic;
  return cardFormFactorOptionValueIds.virtual;
};

export const getCardFormFactorProductOptionValueId = (
  productOptions: ProductOption[],
  cardFormFactor: CardFormFactor,
): number | undefined => {
  const optionValueId = getCardFormFactorOptionValueId(cardFormFactor);
  const productOption = productOptions
    .flatMap(e => e.values)
    .find(e => e.optionValueId === optionValueId);
  return productOption?.optionValueId;
};

export const isGenericCardType = (cardType: CardType): boolean => {
  return (
    cardType === CardType.Vacation ||
    cardType === CardType.Meal ||
    cardType === CardType.Culture ||
    cardType === CardType.Blue
  );
};
